// @ts-check
import React from 'react';

import BusComponent from '../BusComponent';
import MapLayersPanel from "./MapLayersPanel";
import { injectIntl } from 'react-intl';

/**
 * @typedef Props
 * @property {import('../../objects/MapInstance').default} mapInstance
 * @property {boolean} isUserStarterTier
 * @property {import('../MapViewer').default} mapViewer
 * @property {function} onShowDataBrowser
 * @property {string} tourId
 *
 * @typedef State
 * @property {string} mode
 * @property {string} previouslySelectedMode
 * @property {boolean} isMapLayersPanelVisible
 *
 * @extends BusComponent<Props, State>
 */
class MapLayersPanelContainer extends BusComponent {
    constructor(props, context) {
        super(props, context);
        /** @type {Readonly<State>} */
        this.state = {
            isMapLayersPanelVisible: true,
        };

        this.bindGluBusEvents({
            TOGGLE_MAP_LAYERS_PANEL: this.toggleMapLayersPanel,
            COLLAPSE_ALL: this.hideMapLayersPanel,
        });
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }
    
    toggleMapLayersPanel(payload) {
        const { isVisible } = payload;

        const visible = typeof isVisible === 'boolean' ? isVisible : !this.state.isMapLayersPanelVisible;
        this.setState({
            isMapLayersPanelVisible: visible
        });
    }

    hideMapLayersPanel() {
        this.setState({
            isMapLayersPanelVisible: false
        });
    }

    render() {
        const {
            mapInstance,
            mapInstanceIndex,
            isUserStarterTier,
            mapViewer,
            onShowDataBrowser,
            tourId,
            intl,
        } = this.props;
        const { isMapLayersPanelVisible } = this.state;

        const layersButton = (
            <div className="map-layers-panel__container">
                <button
                    className="show-btn"
                    onClick={this.toggleMapLayersPanel.bind(this)}>
                        <i className="material-icons-outlined"> layers </i>
                        <span> {intl.formatMessage({id: 'map.layers' })} </span>
                </button>
            </div>
        );

        return !isMapLayersPanelVisible ? (
            layersButton
        ) : (
            <MapLayersPanel
                mapInstance={mapInstance}
                mapInstanceIndex={mapInstanceIndex}
                isUserStarterTier={isUserStarterTier}
                onShowDataBrowser={onShowDataBrowser}
                mapViewer={mapViewer}
                tourId={tourId}
                onClose={this.toggleMapLayersPanel.bind(this)}
            />
        );
    }
}

export default injectIntl(MapLayersPanelContainer);
